import React, { useState, useEffect } from 'react';
import './ArtistStories.css';
import { useArtistStoriesContent } from '../../../context/ContentContext';

import carouselArrow from '../../../assets/images/carousel-arrow.svg';

const ArtistStories = () => {
    const content = useArtistStoriesContent();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isFading, setIsFading] = useState(false);
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);

    // Preload images
    useEffect(() => {
        if (content && content.stories) {
            content.stories.forEach(story => {
                const img = new Image();
                img.src = require(`../../../assets/images/${story.image}`);
            });
        }
    }, [content]);

    // Minimum swipe distance (in pixels)
    const minSwipeDistance = 50;

    if (!content) return null;

    const { eyebrow, title, stories } = content;

    const onTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
    };

    const onTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const onTouchEnd = () => {
        if (!touchStart || !touchEnd) return;
        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;

        if (isLeftSwipe) {
            handleNext();
        } else if (isRightSwipe) {
            handlePrev();
        }
    };

    const triggerFade = (newIndex) => {
        setIsFading(true);
        setTimeout(() => {
            setCurrentIndex(newIndex);
            setIsFading(false);
        }, 150); // Short delay for fade
    };

    const handleNext = () => {
        if (currentIndex < stories.length - 1) {
            triggerFade(currentIndex + 1);
        }
    };

    const handlePrev = () => {
        if (currentIndex > 0) {
            triggerFade(currentIndex - 1);
        }
    };

    const currentStory = stories[currentIndex];

    return (
        <section className="artist-stories-section" id="artist-stories">
            <div className="artist-stories-container max-width">
                <div className="artist-stories-header">
                    <p className="artist-stories-eyebrow">{eyebrow}</p>
                    <div className="artist-stories-headline">
                        {title.main}
                        <br />
                        <span className="artist-stories-highlight">{title.highlight}</span>
                    </div>
                </div>

                <div
                    className="artist-story-card"
                    onTouchStart={onTouchStart}
                    onTouchMove={onTouchMove}
                    onTouchEnd={onTouchEnd}
                >
                    <div className="artist-story-image-wrap">
                        <img
                            src={require(`../../../assets/images/${currentStory.image}`)}
                            alt={currentStory.name}
                            className="artist-story-image"
                        />
                    </div>

                    <div className={`artist-story-content ${isFading ? 'fading' : ''}`}>
                        <div className="artist-story-quote-wrap">
                            <div className="artist-story-quote">{currentStory.quote}</div>
                            <div className="artist-story-quote">{currentStory.quote2}</div>
                        </div>

                        <div className="artist-story-footer">
                            <div className="artist-story-author">
                                <div className="author-indicator"></div>
                                <div className="author-info">
                                    <h4 className="author-name">{currentStory.name}</h4>
                                    <p className="author-role">{currentStory.role}</p>
                                </div>
                            </div>

                            <div className="artist-story-nav">
                                <button
                                    className={`nav-arrow prev ${currentIndex > 0 ? 'active' : 'inactive'}`}
                                    onClick={handlePrev}
                                    aria-label="Previous story"
                                    disabled={currentIndex === 0}
                                >
                                    <img src={carouselArrow} alt="" />
                                </button>
                                <button
                                    className={`nav-arrow next ${currentIndex < stories.length - 1 ? 'active' : 'inactive'}`}
                                    onClick={handleNext}
                                    aria-label="Next story"
                                    disabled={currentIndex === stories.length - 1}
                                >
                                    <img src={carouselArrow} alt="" />
                                </button>
                            </div>
                        </div>

                        <div className="artist-story-dots">
                            {stories.map((_, index) => (
                                <span
                                    key={index}
                                    className={`dot ${index === currentIndex ? 'active' : ''}`}
                                    onClick={() => triggerFade(index)}
                                ></span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ArtistStories;
